import React from 'react';
import type { MysteryShopCall } from '../../../types/mysteryShop';
import { ScoreBadge } from '../shared';
import { formatDate } from '../utils';

interface RecentCallsProps {
  calls: MysteryShopCall[];
  onSelectCall: (id: string) => void;
}

export const RecentCalls: React.FC<RecentCallsProps> = ({ calls, onSelectCall }) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-100">
    <div className="p-5 border-b border-gray-100">
      <h2 className="font-semibold text-gray-800">Recent Calls</h2>
    </div>
    <div className="divide-y divide-gray-50">
      {calls.map(call => (
        <div
          key={call.id}
          className="p-4 hover:bg-gray-50 cursor-pointer transition-colors"
          onClick={() => onSelectCall(call.id)}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              <p className="font-medium text-gray-800 text-sm truncate">{call.propertyName}</p>
              <p className="text-xs text-gray-500 mt-0.5">
                {call.agentName || 'Unknown Agent'} • {formatDate(call.date)}
              </p>
            </div>
            <ScoreBadge score={call.overallScore} size="sm" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
